<template>
<div class="home">
  <div class="home__title">Inicio</div>
  <AdminHome v-if="isAdmin"/>
  <!-- <div class="home__first">
    <NetoChart/>
    <div class="home__horas">
      <Horas tipo="total" :horas="2453" :oldHoras="2453"/>
      <Horas tipo="simple" :horas="2453" :oldHoras="2202"/>
      <Horas tipo="extra" :horas="2053" :oldHoras="2205"/>
    </div>
  </div> -->
  <div class="home__second">
    <PensionChart :dataChart="pensionData" :key="pensionData.data.lemgth" v-if="pensionData"/>
    <business-chart :dataChart="businessData" :key="businessData.data.length" v-if="businessData"/>
    <!-- <Ingresos/> -->
  </div>
</div>
</template>

<script>
import AdminHome from '@/components/admin/AdminHome'
import NetoChart from '@/components/dashboard/NetoChart'
import PensionChart from '@/components/dashboard/PensionChart'
import BusinessChart from '@/components/dashboard/BusinessChart'
import Ingresos from '@/components/dashboard/Ingresos'
import Horas from '@/components/dashboard/Horas'
import {mapGetters} from 'vuex'

export default {
  components: {
    AdminHome,
    NetoChart,
    PensionChart,
    BusinessChart,
    Ingresos,
    Horas
  },
  beforeCreate(){
    this.$store.dispatch("getDashboardInfo", this.$localStorage.get("businessID"))
    this.$store.dispatch("getDetailBusiness", this.$localStorage.get("businessID"))
  },
  mounted(){
  },

  data() {
    return {
      admin: true
    }
  },

  computed: {
    ...mapGetters({
      isAdmin: 'isAdmin'
    }),
    businessData(){
      // console.log(this.$store.state.business.resumenDashboard, this.$store.state.business.resumenDashboard.clients.length);
      
      if(!this.$store.state.business.resumenDashboard) return null
      return this.$store.state.business.resumenDashboard.clients
    },
    pensionData(){
      if(!this.$store.state.business.resumenDashboard) return null
      return this.$store.state.business.resumenDashboard.employees
    }
  },

  methods: {
  }
}
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #C63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: '../assets/img/';

//2-VENDORS

//3-TOOLS
//functions
//background-image function
@function bimg($img){
  @return url($p-img+$img);
}
//mixins
@mixin mqwh($min-width,$max-height){
  @media (min-width: $min-width) and (max-height: $max-height){
    @content;
  }
}

@mixin mq($min-width){
  @media screen and (min-width: $min-width){
    @content;
  }
}

//8-TRUMPS


.home{
  background-color: #ECEFF8;
  // height: 100%;
  &__title{
    margin: 0 1rem 1rem 1rem;
    padding-top: 1rem;
  }
  &__first{
    margin-top: 2rem;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: center;
    @include mq("700px"){
      flex-direction: row;
      justify-content: center;
      &>*{
        margin: 0 .5rem;
      }
    }
  }
  &__horas{
    &>*{
      margin: 1rem auto;
    }
  }
  &__second{
    // margin-top: 2rem;
    padding-bottom: 15rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: wrap;
    &>*{
      margin: 1rem 0;
      @include mq('700px'){
        // margin: 0 1rem;
      }
    }
    @include mq('700px'){
      // flex-direction: row;
    }
  }
}

</style>
